import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { USER_ID, USER_TYPE } from '../../api/axios';

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showDriverMenu, setShowDriverMenu] = useState(false);
  const [showSupervisorMenu, setShowSupervisorMenu] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const currentUser = sessionStorage.getItem(USER_TYPE);
    const isAdminUser = currentUser.toLowerCase() === 'admin';
    const userId = sessionStorage.getItem(USER_ID);
    setIsAdmin(isAdminUser);
  }, []);

  const handleLogout = async e => {
    e.preventDefault();
    try {
      // Clear session storage
      sessionStorage.clear();
      // Redirect to login page
      navigate('/');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <div
      className="bg-light sidebar vh-100 p-3 border-end"
      style={{ width: '250px', minWidth: '250px' }}
    >
      <h5 className="mb-4">DMS</h5>
      <ul className="nav flex-column">
        <li className="nav-item">
          <Link
            className={`nav-link d-flex align-items-center ${
              location.pathname === '/dashboard' ? 'active-link' : ''
            }`}
            to="/dashboard"
          >
            <i className="fas fa-tachometer-alt me-2"></i> Dashboard
          </Link>
        </li>

        <li className="nav-item">
          <Link
            className={`nav-link d-flex align-items-center ${
              location.pathname === '/driver/attendance' ? 'active-link' : ''
            }`}
            to="/driver/attendance"
          >
            <i className="fas fa-tachometer-alt me-2"></i> Attendance Report
          </Link>
        </li>

        <li className="nav-item">
          <Link
            className={`nav-link d-flex align-items-center ${
              location.pathname === '/driver/attendance/calendar' ? 'active-link' : ''
            }`}
            to="/driver/attendance/calendar"
          >
            <i className="fas fa-tachometer-alt me-2"></i> Monthly Attendance
          </Link>
        </li>

        {/* Drivers Menu */}
        <li className="nav-item">
          <button
            className="btn btn-toggle align-items-center nav-link w-100 text-start"
            onClick={() => setShowDriverMenu(!showDriverMenu)}
          >
            <i className="fas fa-truck me-2"></i> Drivers
          </button>
          {showDriverMenu && (
            <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small ps-3">
              <li>
                <Link
                  className={`nav-link d-flex align-items-center ${
                    location.pathname === '/driver/add' ? 'active-link' : ''
                  }`}
                  to="/driver/add"
                >
                  <i className="fas fa-user-plus me-2"></i> Add Driver
                </Link>
              </li>
              <li>
                <Link
                  className={`nav-link d-flex align-items-center ${
                    location.pathname === '/driver/list' ? 'active-link' : ''
                  }`}
                  to="/driver/list"
                >
                  <i className="fas fa-users me-2"></i> Driver List
                </Link>
              </li>
            </ul>
          )}
        </li>

        {isAdmin && (
          <>
            {/* Supervisor Menu */}
            <li className="nav-item">
              <button
                className="btn btn-toggle align-items-center nav-link w-100 text-start"
                onClick={() => setShowSupervisorMenu(!showSupervisorMenu)}
              >
                <i className="fas fa-user-shield me-2"></i> Supervisor
              </button>
              {showSupervisorMenu && (
                <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small ps-3">
                  <li>
                    <Link
                      className={`nav-link d-flex align-items-center ${
                        location.pathname === '/supervisor/add' ? 'active-link' : ''
                      }`}
                      to="/supervisor/add"
                    >
                      <i className="fas fa-user-tie me-2"></i> Add Supervisor
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`nav-link d-flex align-items-center ${
                        location.pathname === '/supervisor/list' ? 'active-link' : ''
                      }`}
                      to="/supervisor/list"
                    >
                      <i className="fas fa-list me-2"></i> Supervisor List
                    </Link>
                  </li>
                </ul>
              )}
            </li>
          </>
        )}
        <li className="nav-item">
          <a
            href="/login"
            className={`nav-link d-flex align-items-center ${
              location.pathname === '/logout' ? 'active-link' : ''
            }`}
            onClick={handleLogout}
          >
            <i className="fas fa-tachometer-alt me-2"></i> Logout
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
